import { FC } from 'react';

import { SqlQuery } from '../../types';
import styles from './SqlQueryRow.module.css';

type Props = {
  sql: SqlQuery;
  maxTime: number;
};

const SqlQueryRow: FC<Props> = ({ sql, maxTime }) => {
  const percent = (sql.time / maxTime) * 100;
  const barColor = sql.duplicate ? 'red' : 'green';

  return (
    <div className={styles.root}>
      <div
        className={styles.query}
        style={{
          background: `linear-gradient(to right, ${barColor} ${percent}%, transparent ${percent}%)`,
        }}>
        {sql.query}
      </div>

      <div className={styles.time}>{sql.time}</div>
    </div>
  );
};

export default SqlQueryRow;
